function hint(){
	alert("敬请期待")
}

export default{
	hint
}


// WEBPACK FOOTER //
// ./src/common.js